import React from 'react';
import { Button } from 'react-bootstrap';
import './OutlinedPrimaryButton.css';

const OutlinedPrimaryButton = ({
  children,
  onClick,
  disabled = false,
  variant = 'outline-primary',
  size = '',
  className = '',
  // Dynamic styling props with defaults
  width = 'fit-content',
  mobileWidth = null, // Width for mobile devices (< 768px)
  height = 'auto',
  padding = '0.6rem 1.2rem',
  fontSize = '14px',
  fontWeight = '600',
  borderRadius = 'var(--radius-sm)',
  backgroundColor = 'transparent',
  borderColor = 'var(--primary)',
  color = 'var(--primary)',
  hoverBackgroundColor = '',
  hoverBorderColor = '',
  hoverColor = 'var(--primary)',
  boxShadow = 'none',
  hoverBoxShadow = '0 4px 12px rgba(var(--primary-rgb), 0.3)',
  transform = 'none',
  hoverTransform = '',
  transition = 'all 0.2s ease',
  ...props
}) => {
  const dynamicStyle = {
    width,
    height,
    padding,
    fontSize,
    fontWeight,
    borderRadius,
    background: backgroundColor,
    borderColor,
    color,
    boxShadow,
    transform,
    transition,
    // CSS custom properties for hover states
    '--hover-bg': hoverBackgroundColor,
    '--hover-border': hoverBorderColor,
    '--hover-color': hoverColor,
    '--hover-shadow': hoverBoxShadow,
    '--hover-transform': hoverTransform,
    // Mobile width
    '--mobile-width': mobileWidth || width,
    ...props.style
  };

  return (
    <Button
      className={`outlined-primary-btn ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
      variant={variant}
      size={size}
      style={dynamicStyle}
      {...(({ style, ...rest }) => rest)(props)}
    >
      {children}
    </Button>
  );
};

export default OutlinedPrimaryButton;